import React from 'react';
import {
  FilterBox, FilterBoxTitle, FilterItemBox, FilterLineBox,
} from '../style';
import AllFilter from '../utils/ServedFilters/AllFilter';

function ServedTimeFilters({ changeFilter }) {
  return (
    <FilterBox>
      <FilterBoxTitle>Длительность</FilterBoxTitle>
      <FilterItemBox>
        <FilterLineBox>
          <AllFilter
            changeFilter={changeFilter}
            filld="total_wait_time"
            title="Ожидания"
            smallTitle="true"
            timeFilter="timeFilter"
          />
        </FilterLineBox>
        <FilterLineBox>
          <AllFilter
            changeFilter={changeFilter}
            filld="total_proc_time"
            title="Oбслужи-вания"
            smallTitle="true"
            timeFilter="timeFilter"
          />
        </FilterLineBox>
      </FilterItemBox>
    </FilterBox>
  );
}
export default ServedTimeFilters;
